<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="regulationsService"
    [idKey]="'regulationId'"
></base-index-page>